function AddItemToCart()
{
    addonsToCart('https://www.overnightflowers.com/cart');
}



function AddItemCheckout()
{
    addonsToCart();
}

async function addonsToCart( redirectLocation ) {
	var variantValue = $("#ProductSelect-" + CMATION_ProductId ).val();
	$("#AddToCart-" + CMATION_ProductId ).addClass('btn--loading');

  	var props = {};
    // PROCESS ADDONS FIRST
  	let selectedAddons = $('.addon_cb:checked');
    if (selectedAddons.length > 0)
    {
        for (index = 0; index <= selectedAddons.length - 1; index++)
        {
			tmpName = selectedAddons[index].name;
			tmpName = tmpName.replace("addon[","");
			tmpName = tmpName.replace("]","");
          
          	tmpValue = selectedAddons[index].value;
          
          	tmpAttrName = $(selectedAddons[index]).data("name");
          
            props[tmpName] = tmpAttrName;
          /*
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    quantity: 1,
                    id: selectedAddons[index].value,
                  	properties: props
                })
            });
            //const product = await response.json();
            */
        }
    }

    	const swaqInput = document.querySelector('#swaq-atc');
	const hasSwaqCode = swaqInput.checked;
  
  	props["Delivery Zip"] = $('#txtBespokeCalendarZip').val();
  	props["Delivery Date"] = $('#txtBespokeCalendarDate').val();
  	props["_DC"] = $('#txtBespokeDC').val();
  	props["Recipient"] = $('#txtBespokeCalendarRecipient').val();
  	props["Gift Message"] = $('#txtBespokeCalendarGift').val();
  	props["Photo"] = $('.uploadkit .uploadkit-uploader input[name="properties[Photo]"]').val();
  	props["_Photo"] = $('.uploadkit .uploadkit-uploader input[name="properties[_Photo (direct link)]"]').val();

    
	const itemsToAdd = [{
					        quantity: 1,
            id: variantValue,
          	properties: props
				}];

	if(hasSwaqCode){
		itemsToAdd.push({
			quantity: 1,
			id: swaqInput.value,
		})
	}
  	
    const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
           items:itemsToAdd
        })
    });
    //const product = await response.json();




    if (typeof(redirectLocation) !== 'undefined') {
        setTimeout(function(){ window.location.href = redirectLocation; }, 1000);
    }
}

async function changeSelection()
{
    $("#CMATION_Addons").html('');
    let selectedVariant = $('.variant__input-' + CMATION_ProductId + ':radio:checked').val();
    if (selectedVariant != '')
    {
        for (index = 0; index <= CMATION_addonItemIds.length - 1; index++)
        {
            let currentTitle = '';
            if (CMATION_addonItemIds[index].productName == selectedVariant)
            {
                const response = await fetch('/products/' + CMATION_addonItemIds[index].productHandle + '.js');
                const product = await response.json();
                if (typeof (product.variants) != 'undefined')
                {
                    for (let i2 = 0; i2 <= product.variants.length - 1; i2++)
                    {
                        let variant = product.variants[i2];
                      let addonArrayLength = 0;
                        let categoryTitle =  variant.name.replace(" - " + variant.title, "");
                      	if (typeof(CMATION_addonItemIds[index].addons) !== 'undefined') {
                      		addonArrayLength = CMATION_addonItemIds[index].addons.length;
                      	}
                        if (addonArrayLength != 0) {

                          if (currentTitle !== categoryTitle)
                          {
                              $("#CMATION_Addons").append('<div class="addonTitle">' + categoryTitle + '</div>');
                              currentTitle=categoryTitle;
                          }
                          if (inArray(variant.id, CMATION_addonItemIds[index].addons))
                          {
                              if (categoryTitle === 'Vases')
                              {
                                  $("#CMATION_Addons").append('<div class="addon"><input type="radio" id="addon[' + variant.id + ']" name="addon[' + categoryTitle + ']" class="addon_cb" value="' + variant.id + '" data-name="' + variant.title + '"><label for="addon[' + variant.id + ']"><img src="' + variant.featured_image.src + '" alt="' + variant.title + '"><hr noshade>' + variant.title + '<br>' + displayPrice(variant.price) + '<br></label></div>');
                                  document.getElementById('addon[' + variant.id + ']').addEventListener("click", function () {
                                      if (clickedNum == this.value) {
                                          this.checked = false;
                                          clickedNum = 0;
                                      } else {
                                          clickedNum = this.value;
                                      }
                                  });
                              }
                              else
                              {
                                  $("#CMATION_Addons").append('<div class="addon"><input type="radio" id="addon[' + variant.id + ']" name="addon[' + categoryTitle + ']" class="addon_cb" value="' + variant.id + '" data-name="' + variant.title + '"><label for="addon[' + variant.id + ']"><img src="' + variant.featured_image.src + '" alt="' + variant.title + '"><hr noshade>' + variant.title + '<br>' + displayPrice(variant.price) + '<br></label></div>');
                              }
                          }
                        }
                    }
                }
            }
        }
    }
}

function inArray(needle, haystack)
{
    var length = haystack.length;
    for (var i = 0; i < length; i++)
    {
        if (haystack[i] == needle) return true;
    }
    return false;
};

function displayPrice(price)
{
    if (price == 0) return "Included";
    return formatter.format(price/100);
}

const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
});

var clickedNum;
var addonHTML='';
var variantIds = [];
var handles = [];
var selectedAddon = '';
var selectedVariant = "";

// UPDATES CLICK EVENT ON PRODUCT VARIANTS
var variantOptions = document.getElementsByClassName("variant__input-" + CMATION_ProductId);
for (i = 0; i < variantOptions.length; i++)
{
    variantOptions[i].addEventListener('click', function(evt) {
        changeSelection();
    });
}

changeSelection();

$('textarea').keyup(function() {
    
  var characterCount = $(this).val().length,
      current = $('#current'),
      maximum = $('#maximum'),
      theCount = $('#the-count');
    
  current.text(characterCount);
 
  
  /*This isn't entirely necessary, just playin around*/
  if (characterCount < 70) {
    current.css('color', '#666');
  }
  if (characterCount > 70 && characterCount < 90) {
    current.css('color', '#6d5555');
  }
  if (characterCount > 90 && characterCount < 100) {
    current.css('color', '#793535');
  }
  if (characterCount > 100 && characterCount < 120) {
    current.css('color', '#841c1c');
  }
  if (characterCount > 120 && characterCount < 139) {
    current.css('color', '#8f0001');
  }
  
  if (characterCount >= 140) {
    maximum.css('color', '#8f0001');
    current.css('color', '#8f0001');
    theCount.css('font-weight','bold');
  } else {
    maximum.css('color','#666');
    theCount.css('font-weight','normal');
  }
  
      
});

$(document).ready(function() {
  $('#991d1677-417a-4c2b-8d05-c9d73707c952').live('click', function() {
        $(this).addClass('active');
    });
});   



